var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "logos-app-root" }, [
    _vm.showControls
      ? _c("div", { staticClass: "controls" }, [
          _c("div", [
            _c("label", { attrs: { for: "logos-app-controls-name" } }, [
              _vm._v("Logo Name")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.new_logo.name,
                  expression: "new_logo.name"
                }
              ],
              attrs: { id: "logos-app-controls-name", name: "name" },
              domProps: { value: _vm.new_logo.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.new_logo, "name", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", { attrs: { for: "logos-app-controls-file" } }, [
              _vm._v("Upload a new image")
            ]),
            _vm._v(" "),
            _c("input", {
              ref: "filepicker",
              attrs: {
                id: "logos-app-controls-file",
                type: "file",
                name: "file"
              },
              on: { change: _vm.previewFileUpload }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "external" }, [
            _c("label", { attrs: { for: "logos-app-controls-url" } }, [
              _vm._v("or Add an image from the internet")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.new_logo.url,
                    expression: "new_logo.url"
                  }
                ],
                attrs: {
                  id: "logos-app-controls-url",
                  name: "external_url",
                  placeholder: "Image URL"
                },
                domProps: { value: _vm.new_logo.url },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.new_logo, "url", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("button", { on: { click: _vm.fetchExternal } }, [
                _vm._v("Preview")
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.new_logo.imagePreview
            ? _c("img", {
                staticClass: "preview",
                attrs: { src: _vm.new_logo.imagePreview }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.saving
            ? _c(
                "button",
                { staticClass: "save", on: { click: _vm.saveNewLogo } },
                [_vm._v("Save new logo")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.saving
            ? _c("img", {
                staticClass: "saving",
                attrs: { src: "/icons/saving.gif" }
              })
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "list" }, [
      _c("div", { staticClass: "list-filter" }, [
        _c("label", { attrs: { for: "logos-app-list-filter" } }, [
          _vm._v("Filter list")
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.filter,
              expression: "filter"
            }
          ],
          attrs: { id: "logos-app-list-filter", name: "list-filter" },
          domProps: { value: _vm.filter },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.filter = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "logos-list" },
        [
          _c("input", { ref: "logoCopy", staticClass: "hide-offscreen" }),
          _vm._v(" "),
          _vm._l(_vm.logos, function(logo) {
            return logo.name.toLowerCase().includes(_vm.filter.toLowerCase())
              ? _c("div", { staticClass: "logo" }, [
                  _c("div", [
                    _c("div", { staticClass: "img" }, [
                      _c("a", { attrs: { href: logo.image } }, [
                        _c("img", { attrs: { src: logo.image } })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("h3", [_vm._v(_vm._s(logo.name))]),
                      _vm._v(" "),
                      _c("a", { attrs: { href: logo.image } }, [
                        _vm._v(_vm._s(logo.image))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      class:
                        _vm.copyLogoImage === logo.image ? "secondary" : "",
                      on: {
                        click: function($event) {
                          _vm.copy(logo.image, $event)
                        }
                      }
                    },
                    [_vm._v("Copy")]
                  )
                ])
              : _vm._e()
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dec78616", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dec78616","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/logos-app.vue
// module id = 544
// module chunks = 0